import { Container } from "@/components/customComponents";
import ConfirmEmailChangeForm from "@/pages/UpdateEmail/components/ConfirmEmailChangeForm";
import RequestEmailChangeForm from "@/pages/UpdateEmail/components/RequestEmailChangeForm";
import { EmailChangeStep } from "@/pages/UpdateEmail/constants";
import useEmailChangeFlow from "@/pages/UpdateEmail/hooks/useEmailChangeFlow";

type UpdateEmailProps = {
  "data-testid"?: string;
};

const UpdateEmail = ({ "data-testid": testId = "UpdateEmail" }: UpdateEmailProps) => {
  const {
    step,
    pendingEmail,
    isRequestingCode,
    isConfirmingCode,
    hasExpired,
    secondsUntilExpiry,
    secondsUntilResend,
    requestErrorMessage,
    confirmErrorMessage,
    requestCode,
    confirmCode,
    resendCode,
    editEmail,
  } = useEmailChangeFlow();

  return (
    <div data-testid={testId}>
      <Container>
        <div className="flex w-full max-w-[640px] flex-col px-6 py-10">
          {step === EmailChangeStep.CONFIRM ? (
            <ConfirmEmailChangeForm
              pendingEmail={pendingEmail}
              secondsUntilExpiry={secondsUntilExpiry}
              secondsUntilResend={secondsUntilResend}
              hasExpired={hasExpired}
              isSubmitting={isConfirmingCode}
              isResending={isRequestingCode}
              errorMessage={confirmErrorMessage}
              onSubmit={confirmCode}
              onResend={resendCode}
              onEditEmail={editEmail}
            />
          ) : (
            <RequestEmailChangeForm
              defaultEmail={pendingEmail}
              isSubmitting={isRequestingCode}
              errorMessage={requestErrorMessage}
              onSubmit={requestCode}
            />
          )}
        </div>
      </Container>
    </div>
  );
};

export default UpdateEmail;
